// import router from '@/router'
import { isObject } from '@/Composable/utils'
import { includeAny } from '@/Composable/utils.js';
import { computed } from 'vue'
import { usePage } from '@inertiajs/vue3'

export default () => {
    const navLinkProps = computed(() => item => {
        const props = {
            href: '#',
        };

        try {
            // Logging the item to check what is being passed

            if (item && item.to) {
                if (item.params && (Array.isArray(item.params) || typeof item.params === 'object')) {
                    props.href = typeof item.to === 'string' ? route(item.to, item.params) : route(item.to, item.params);
                } else if (item.params && item.params !== '') {
                    props.href = typeof item.to === 'string' ? route(item.to, item.params) : route(item.to, item.params);
                } else {
                    props.href = typeof item.to !== 'undefined' && typeof item.to === 'string' ? route(item.to) : '#';
                }
            } else if (item && item.href) {
                props.href = item.href;
                props.target = '_blank';
                props.rel = 'nofollow';
            }

            if (item && !props.target) {
                props.target = item.target;
            }

            // Logging the props to see the final output

            return props;
        } catch (error) {
            // console.error('Error in navLinkProps:', error);
            return props; // Return default props in case of error
        }
    });

    /**
     * Return route name for navigation link
     * If link is string then it will assume it is route-name
     * IF link is object it will resolve the object and will return the link
     * @param {Object, String} link navigation link object/string
     */
    // const resolveNavLinkRouteName = link => {
    //   if (isObject(link.to)) {
    //     const { route } = router.resolve(link.to)

    //     return route.name
    //   }

    //   return link.to
    // }

    /**
     * Check if nav-link is active
     * @param {Object} link nav-link object
     */

    const isNavLinkActive = link => {


        return route().current(link.to) && includeAny(usePage().props.getFullUrl, link.url);
        // // if getFullUrl contains link.to
        // if (link.hasOwnProperty('url') && link.url != null) {
        //     if (includeAny(usePage().props.getFullUrl, link.url)) {
        //         return true;
        //     }
        // } else {
        //     return usePage().props.getRouteName == link.to || route().current(link.to);
        // }



    }


    /**
     * Check if nav group is
     * @param {Array} children Group children
     */
    // eslint-disable-next-line arrow-body-style
    const isNavGroupActive = children => {

        if (isNavLinkActive(children)) {
            return true;
        }
        if (typeof children == 'array') {

            return children.map(child => {
                if (child.children) {
                    return isNavGroupActive(child.children)
                }

                return isNavLinkActive(child)
            })
        }
        if (typeof children == 'object') {


            Object.keys(children).forEach(function (key, index) {
                if (children[key].children) {
                    return isNavGroupActive(children[key].children)
                }
                return isNavLinkActive(children[key])
            });

        }

    }

    return {
        navLinkProps,
        isNavLinkActive,
        isNavGroupActive,
    }
}
